<template>
    <svg t="1648623955226" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="26037" width="200" height="200">
        <path d="M597.333333 381.738667L938.666667 597.333333v85.333334l-341.333334-107.776v228.693333l128 71.082667V938.666667l-192-42.666667L341.333333 938.666667v-64l128-71.125334v-228.693333L128 682.666667v-85.333334l341.333333-215.594666V149.333333a64 64 0 0 1 128 0v232.405334z" p-id="26038"></path>
    </svg>
</template>

